// src/modules/clinical-note-ai/components/AnalysisSkeleton.jsx

import React from 'react';
import { Card, CardContent, Skeleton, Stack } from '@mui/material';

const AnalysisSkeleton = () => (
  <Card sx={{ borderRadius: 3 }}>
    <CardContent>
      <Stack spacing={1.5}>
        <Skeleton variant="text" height={32} />
        <Skeleton variant="rectangular" height={80} sx={{ borderRadius: 2 }} />
        <Skeleton variant="text" height={24} />
        <Skeleton variant="rectangular" height={140} sx={{ borderRadius: 2 }} />
        <Skeleton variant="text" height={24} />
        <Skeleton variant="rectangular" height={140} sx={{ borderRadius: 2 }} />
      </Stack>
    </CardContent>
  </Card>
);

export default AnalysisSkeleton;
